<template>
  <!-- Navbar Start -->
  <div class="container-fluid fixed-top px-0 wow fadeIn" data-wow-delay="0.1s">
    <div
      class="top-bar text-white-50 row gx-0 align-items-center d-none d-lg-flex"
    >
      <div class="col-lg-6 px-5 text-start">
        <small
          ><i class="fa fa-map-marker-alt me-2"></i>1820 Versailles rd,
          Lexington, KY 40504, USA</small
        >
        <small class="ms-4"
          ><i class="fa fa-envelope me-2"></i>info@pishonministry.com</small
        >
      </div>
      <div class="col-lg-6 px-5 text-end">
        <small>Follow us:</small>
        <a class="text-white-50 ms-3" href=""
          ><i class="fab fa-facebook-f"></i
        ></a>
        <a class="text-white-50 ms-3" href=""><i class="fab fa-twitter"></i></a>
        <a class="text-white-50 ms-3" href=""
          ><i class="fab fa-linkedin-in"></i
        ></a>
        <a class="text-white-50 ms-3" href=""
          ><i class="fab fa-instagram"></i
        ></a>
      </div>
    </div>

    <nav
      class="navbar navbar-expand-lg navbar-dark py-lg-0 px-lg-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <a href="/" class="navbar-brand ms-4 ms-lg-0">
        <h1 class="fw-bold text-primary m-0">
          Pishon <span class="text-white">Ministry</span>
        </h1>
      </a>
      <button
        type="button"
        class="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="navbar-nav ms-auto p-4 p-lg-0">
          <a href="/" class="nav-item nav-link active">Home</a>
          <a href="/about" class="nav-item nav-link">About</a>
          <a href="/service" class="nav-item nav-link">Services</a>
          <a href="/contact" class="nav-item nav-link">Contact</a>
        </div>
        <div class="d-none d-lg-flex ms-2">
          <a class="btn btn-outline-primary py-2 px-3" href="/donate">
            Donate Now
            <div
              class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
            >
              <i class="fa fa-arrow-right"></i>
            </div>
          </a>
        </div>
      </div>
    </nav>
  </div>
  <!-- Navbar End -->

  <!-- Carousel Start -->
  <div class="container-fluid p-0 mb-5">
    <div id="header-carousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img class="w-100" src="img/home1.png" alt="Image" />
          <div class="carousel-caption">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-7 pt-5">
                  <h1 class="display-4 text-white mb-3 animated slideInDown">
                    The Pishon Ministry
                  </h1>
                  <p class="fs-5 text-white-50 mb-5 animated slideInDown">
                    Spreading the gospel through worship and praise
                  </p>
                  <a
                    class="btn btn-primary py-2 px-3 animated slideInDown"
                    href=""
                  >
                    Learn More
                    <div
                      class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
                    >
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <img class="w-100" src="img/home2.png" alt="Image" />
          <div class="carousel-caption">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-7 pt-5">
                  <h1 class="display-4 text-white mb-3 animated slideInDown">
                    The Pishon Ministry
                  </h1>
                  <p class="fs-5 text-white-50 mb-5 animated slideInDown">
                    Spreading the gospel through worship and praise
                  </p>
                  <a
                    class="btn btn-primary py-2 px-3 animated slideInDown"
                    href=""
                  >
                    Learn More
                    <div
                      class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
                    >
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <img class="w-100" src="img/home3.png" alt="Image" />
          <div class="carousel-caption">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-7 pt-5">
                  <h1 class="display-4 text-white mb-3 animated slideInDown">
                    The Pishon Ministry
                  </h1>
                  <p class="fs-5 text-white-50 mb-5 animated slideInDown">
                    Spreading the gospel through worship and praise
                  </p>
                  <a
                    class="btn btn-primary py-2 px-3 animated slideInDown"
                    href=""
                  >
                    Learn More
                    <div
                      class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
                    >
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <img class="w-100" src="img/home4.png" alt="Image" />
          <div class="carousel-caption">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-7 pt-5">
                  <h1 class="display-4 text-white mb-3 animated slideInDown">
                    The Pishon Ministry
                  </h1>
                  <p class="fs-5 text-white-50 mb-5 animated slideInDown">
                    Spreading the gospel through worship and praise
                  </p>
                  <a
                    class="btn btn-primary py-2 px-3 animated slideInDown"
                    href=""
                  >
                    Learn More
                    <div
                      class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
                    >
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#header-carousel"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
  <!-- Carousel End -->

  <!-- About Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div class="row g-5">
        <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
          <div
            class="position-relative overflow-hidden h-100"
            style="min-height: 400px"
          >
            <img
              class="position-absolute w-100 h-100 pt-5 pe-5"
              src="img/home1.jpeg"
              alt=""
              style="object-fit: cover"
            />
            <img
              class="position-absolute top-0 end-0 bg-white ps-2 pb-2"
              src="img/home2.jpeg"
              alt=""
              style="width: 200px; height: 200px"
            />
          </div>
        </div>
        <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="h-100">
            <div
              class="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3"
            >
              About Us
            </div>
            <h1 class="display-6 mb-5">
              About The Pishon Ministry And Our Mission
            </h1>
            <div
              class="bg-light border-bottom border-5 border-primary rounded p-4 mb-4"
            >
              <p class="text-dark mb-2">
                Our mission is to glorify God through worship, using music as a
                tool to touch hearts, bring healing, and unite believers in His
                love
              </p>
              <span class="text-primary">Pishon Ministry</span>
            </div>
            <p class="mb-5">
              Pishon Ministry is a passionate community of worshipers dedicated
              to spreading the love of Christ through song and fellowship.
              Rooted in faith and devotion, we use the power of music to
              inspire, uplift, and bring people closer to God. Through heartfelt
              worship and meaningful connections, we strive to create an
              atmosphere where lives are transformed and faith is strengthened.
            </p>
            <a class="btn btn-primary py-2 px-3 me-3" href="/about">
              Learn More
              <div
                class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
              >
                <i class="fa fa-arrow-right"></i>
              </div>
            </a>
            <a class="btn btn-outline-primary py-2 px-3" href="/contact">
              Contact Us
              <div
                class="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2"
              >
                <i class="fa fa-arrow-right"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- About End -->

  <!-- Causes Start -->
  <div class="container-xxl bg-light my-5 py-5">
    <div class="container py-5">
      <div
        class="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <div
          class="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3"
        >
          What we Do
        </div>
        <h1 class="display-6 mb-5">
          <!-- Every Child Deserves The Opportunity To Learn -->
        </h1>
      </div>
      <div class="row g-4 justify-content-center">
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div
            class="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100"
          >
            <div class="text-center p-4 pt-0">
              <div
                class="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4"
              >
                <small>Worship Services</small>
              </div>
              <h5 class="mb-3">Worship Services</h5>
              <p>
                Leading worship and spreading the gospel through powerful music
              </p>
            </div>
            <div class="position-relative mt-auto">
              <img class="img-fluid" src="img/home2.jpeg" alt="" />
              <div class="causes-overlay">
                <a class="btn btn-outline-primary" href="">
                  Read More
                  <div
                    class="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2"
                  >
                    <i class="fa fa-arrow-right"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
          <div
            class="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100"
          >
            <div class="text-center p-4 pt-0">
              <div
                class="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4"
              >
                <small>Community Outreach</small>
              </div>
              <h5 class="mb-3">Community Outreach</h5>
              <p>
                Serving the community through charity and evangelism programs
              </p>
            </div>
            <div class="position-relative mt-auto">
              <img class="img-fluid" src="img/volunteer1.jpeg" alt="" />
              <div class="causes-overlay">
                <a class="btn btn-outline-primary" href="">
                  Read More
                  <div
                    class="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2"
                  >
                    <i class="fa fa-arrow-right"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div
            class="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100"
          >
            <div class="text-center p-4 pt-0">
              <div
                class="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4"
              >
                <small>Youth Ministry</small>
              </div>
              <h5 class="mb-3">Youth Ministry</h5>
              <p>
                Engaging the next generation in spiritual growth and worship
              </p>
            </div>
            <div class="position-relative mt-auto">
              <img
                class="img-fluid"
                src="img/CMG-Editor-January-15-2020.jpeg"
                alt=""
              />
              <div class="causes-overlay">
                <a class="btn btn-outline-primary" href="">
                  Read More
                  <div
                    class="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2"
                  >
                    <i class="fa fa-arrow-right"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Causes End -->

  <!-- Donate Start -->
  <div
    class="container-fluid donate my-5 py-5"
    data-parallax="scroll"
    data-image-src="img/home2.png"
  >
    <div class="container py-5">
      <div class="row g-5 align-items-center">
        <div class="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
          <div
            class="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3"
          >
            Support Our Ministry
          </div>
          <h1 class="display-6 text-white mb-5">
            Thanks For The Results Achieved With You
          </h1>
          <p class="text-white-50 mb-0">
            Your generosity helps Pishon Ministry continue its mission of
            spreading the love of Christ through worship and fellowship. By
            donating, you support our efforts to reach more people, organize
            worship events, and create inspiring music that touches hearts and
            transforms lives. Every contribution, big or small, makes a
            difference in advancing God’s work.
          </p>
        </div>
        <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
          <div class="h-100 bg-white p-5">
            <form>
              <div class="row g-3">
                <div class="col-12">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control bg-light border-0"
                      id="name"
                      placeholder="Your Name"
                    />
                    <label for="name">Your Name</label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-floating">
                    <input
                      type="email"
                      class="form-control bg-light border-0"
                      id="email"
                      placeholder="Your Email"
                    />
                    <label for="email">Your Email</label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="btn-group d-flex justify-content-around">
                    <input
                      type="radio"
                      class="btn-check"
                      name="btnradio"
                      id="btnradio1"
                      checked
                    />
                    <label class="btn btn-light py-3" for="btnradio1"
                      >$10</label
                    >

                    <input
                      type="radio"
                      class="btn-check"
                      name="btnradio"
                      id="btnradio2"
                    />
                    <label class="btn btn-light py-3" for="btnradio2"
                      >$20</label
                    >

                    <input
                      type="radio"
                      class="btn-check"
                      name="btnradio"
                      id="btnradio3"
                    />
                    <label class="btn btn-light py-3" for="btnradio3"
                      >$30</label
                    >
                  </div>
                </div>
                <div class="col-12">
                  <button class="btn btn-primary px-5" style="height: 60px">
                    Donate Now
                    <div
                      class="d-inline-flex btn-sm-square bg-white text-primary rounded-circle ms-2"
                    >
                      <i class="fa fa-arrow-right"></i>
                    </div>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Donate End -->

  <!-- Team Start -->
  <div class="container-xxl py-5">
    <div class="container">
      <div
        class="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style="max-width: 500px"
      >
        <div
          class="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3"
        >
          Team Members
        </div>
        <h1 class="display-6 mb-5">Let's Meet With Our Ordinary Team</h1>
      </div>
      <div class="row g-4">
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
          <div class="team-item position-relative rounded overflow-hidden">
            <div class="overflow-hidden">
              <img class="img-fluid" src="img/president.jpeg" alt="" />
            </div>
            <div class="team-text bg-light text-center p-4">
              <h5>Uwitonze Mukashema</h5>
              <p class="text-primary">President</p>
              <div class="team-social text-center">
                <a class="btn btn-square" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
          <div class="team-item position-relative rounded overflow-hidden">
            <div class="overflow-hidden">
              <img class="img-fluid" src="img/vice-president.jpeg" alt="" />
            </div>
            <div class="team-text bg-light text-center p-4">
              <h5>James Iyamuremye</h5>
              <p class="text-primary">Vice President</p>
              <div class="team-social text-center">
                <a class="btn btn-square" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
          <div class="team-item position-relative rounded overflow-hidden">
            <div class="overflow-hidden">
              <img class="img-fluid" src="img/conductor.jpeg" alt="" />
            </div>
            <div class="team-text bg-light text-center p-4">
              <h5>Innocent Murenzi</h5>
              <p class="text-primary">Conductor</p>
              <div class="team-social text-center">
                <a class="btn btn-square" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
          <div class="team-item position-relative rounded overflow-hidden">
            <div class="overflow-hidden">
              <img
                class="img-fluid"
                src="img/assistant-conductor.jpeg"
                alt=""
              />
            </div>
            <div class="team-text bg-light text-center p-4">
              <h5>Fazili Patient</h5>
              <p class="text-primary">Assistant Conductor</p>
              <div class="team-social text-center">
                <a class="btn btn-square" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
          <div class="team-item position-relative rounded overflow-hidden">
            <div class="overflow-hidden">
              <img class="img-fluid" src="img/secretary.jpeg" alt="" />
            </div>
            <div class="team-text bg-light text-center p-4">
              <h5>Alpha Nsazamahoro</h5>
              <p class="text-primary">Secretary</p>
              <div class="team-social text-center">
                <a class="btn btn-square" href=""
                  ><i class="fab fa-facebook-f"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-twitter"></i
                ></a>
                <a class="btn btn-square" href=""
                  ><i class="fab fa-instagram"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Team End -->

  <!-- Footer Start -->
  <div
    class="container-fluid bg-dark text-white-50 footer mt-5 pt-5 wow fadeIn"
    data-wow-delay="0.1s"
  >
    <div class="container py-5">
      <div class="row g-5">
        <div class="col-lg-3 col-md-6">
          <h3 class="fw-bold text-primary mb-4">
            Pishon<span class="text-white"> Ministry</span>
          </h3>
          <p>
            Pishon Ministry is a passionate community of worshipers dedicated to
            spreading the love of Christ through song and fellowship
          </p>
          <div class="d-flex pt-2">
            <a class="btn btn-square me-1" href=""
              ><i class="fab fa-twitter"></i
            ></a>
            <a class="btn btn-square me-1" href=""
              ><i class="fab fa-facebook-f"></i
            ></a>
            <a class="btn btn-square me-1" href=""
              ><i class="fab fa-youtube"></i
            ></a>
            <a class="btn btn-square me-0" href=""
              ><i class="fab fa-linkedin-in"></i
            ></a>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <h5 class="text-light mb-4">Address</h5>
          <p>
            <i class="fa fa-map-marker-alt me-3"></i>1820 Versailles rd,
            Lexington, KY 40504, USA
          </p>
          <p><i class="fa fa-phone-alt me-3"></i>+1 (859) 351-8924</p>
          <p><i class="fa fa-envelope me-3"></i>info@pishonministry.com</p>
        </div>
        <div class="col-lg-3 col-md-6">
          <h5 class="text-light mb-4">Quick Links</h5>
          <a class="btn btn-link" href="/about">About Us</a>
          <a class="btn btn-link" href="/contact">Contact Us</a>
          <a class="btn btn-link" href="/service">Our Services</a>
          <a class="btn btn-link" href="">Terms & Condition</a>
          <a class="btn btn-link" href="">Support</a>
        </div>
        <div class="col-lg-3 col-md-6">
          <h5 class="text-light mb-4">Newsletter</h5>
          <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
          <div class="position-relative mx-auto" style="max-width: 400px">
            <input
              class="form-control bg-transparent w-100 py-3 ps-4 pe-5"
              type="text"
              placeholder="Your email"
            />
            <button
              type="button"
              class="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
            >
              SignUp
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid copyright">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
            &copy; <a href="#">Pishon Ministry</a>, All Right Reserved.
          </div>
          <div class="col-md-6 text-center text-md-end">
            Designed By <a href="https://tambagroup.xyz">Tamba Group</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer End -->

  <!-- Back to Top -->
  <a href="#" class="btn btn-lg btn-primary btn-lg-square back-to-top"
    ><i class="bi bi-arrow-up"></i
  ></a>
</template>
